import MultiTourHandlerSingleton from 'ui-shepherd-react/lib/MultiTourHandlerSingleton';
import UITour from 'ui-shepherd-react/tour/UITour';
import { ALL_TOURS, STEP_TO_OPTIONS } from './onboardingTourConfig';
import UITourStep from 'ui-shepherd-react/tour/UITourStep';
import useOnboardingTour from './useOnboardingTour';
import UITourNextButton from 'ui-shepherd-react/button/UITourNextButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITourFinishButton from 'ui-shepherd-react/button/UITourFinishButton';
import { useDispatch } from 'react-redux';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const tourHandler = MultiTourHandlerSingleton.getInstance();
ALL_TOURS.forEach(({
  key,
  config
}) => tourHandler.registerTour(key, config));
export const OnboardingTourContext = ({
  children
}) => /*#__PURE__*/_jsx(UITour, {
  multiTourHandler: tourHandler,
  activateOnMount: false,
  tours: ALL_TOURS.map(({
    key
  }) => key),
  children: children
});
export const OnboardingFooter = ({
  hideNextButton
}) => {
  const dispatch = useDispatch();
  const {
    getIsLastStep,
    finishOptions
  } = useOnboardingTour();
  const {
    beforeFinishReduxAction,
    finishLangKey
  } = finishOptions;
  const isLastStep = getIsLastStep();
  const dispatchBeforeFinishAction = () => {
    if (beforeFinishReduxAction) {
      dispatch(beforeFinishReduxAction);
    }
  };
  return isLastStep ? /*#__PURE__*/_jsx(UITourFinishButton, {
    beforeFinish: () => dispatchBeforeFinishAction(),
    use: "primary",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `tours.footer.${finishLangKey || 'finish'}`
    })
  }) : /*#__PURE__*/_jsx("div", {
    children: !hideNextButton && /*#__PURE__*/_jsx(UITourNextButton, {
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "tours.footer.nextStep"
      })
    })
  });
};
export const OnboardingStep = ({
  stepId,
  children
}) => {
  const {
    attachTo,
    placement,
    hideNextButton,
    pulser = true
  } = STEP_TO_OPTIONS[stepId];
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(UITourStep, {
      "data-test-id": "tour-step",
      showSteps: true,
      showCloseButton: true,
      pulser: pulser,
      content: {
        header: /*#__PURE__*/_jsx(Text, {
          as: "h4",
          color: "fill-surface-default",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `tours.${stepId}.title`
          })
        }),
        body: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `tours.${stepId}.message`
        }),
        footer: /*#__PURE__*/_jsx(OnboardingFooter, {
          hideNextButton: !!hideNextButton
        })
      },
      stepKey: stepId,
      attachTo: attachTo,
      placement: placement,
      children: children
    })
  });
};
export const OnboardingTour = () => {
  const {
    tourSteps
  } = useOnboardingTour();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: tourSteps
    // render all steps anchored via attachTo, those without need to be embedded manually
    .filter(stepId => STEP_TO_OPTIONS[stepId].attachTo).map(stepId => {
      return /*#__PURE__*/_jsx(OnboardingStep, {
        stepId: stepId
      }, stepId);
    })
  });
};